const responseHome = {
    "payload": {
        "adminFirstName": "Ibliss",
        "adminLastName": "Core",
        "welcomeTitle": "Titulo de Bienvenida",
        "welcomeBody": "Texto de Bienvenida",
        "welcomeImageUrl": "https://ibliss-icons-prod.s3.amazonaws.com/marca_empresarial/cajapadre.png",
        "companyLogo": "https://ibliss-icons-prod.s3.amazonaws.com/clients/lucasianlabs.svg",
        "companyName": "Caja padre",
        "hasBusinessBranding": true,
        "role" : {
            "roleId":2,
            "roleName":"ADMINISTRADOR"
        }
    } 
};
  
  export const service = {
    getHome: () => new Promise(resolve => {
      setTimeout(resolve({ data: responseHome }), 1000);
    }),
  
  }